import React, { useState, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { CiCircleRemove } from "react-icons/ci";
import axios from "axios";
import config from "../config";
import { useAuth } from "../context/AuthContext";
import CustomToast from "../components/CustomToast";
import { Button } from 'primereact/button';

const AddUserDocuments = ({ userId, userDocuments, setDocumentModal1, fetchUserDocuments }) => {
    const { accessToken } = useAuth();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const toastRef = useRef(null);

    // ✅ Custom Toast helper
    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        if (files.length > 2) {
            showMessage("warn", "You can upload a maximum of 2 files at once.");
            return;
        }

        if ((userDocuments?.length || 0) === 2) {
            showMessage(
                "info",
                "You already have 2 documents. Uploading new ones will replace the oldest ones."
            );
        }

        setSelectedFiles(files);
    };


    const handleRemoveFile = (index) => {
        const updated = [...selectedFiles];
        updated.splice(index, 1);
        setSelectedFiles(updated);
    };

    const handleUpload = async () => {
        if (selectedFiles.length === 0) {
            showMessage("warn", "Please select at least one document to upload.");
            return;
        }

        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append("userId", userId);
            selectedFiles.forEach((file) => formData.append("documents", file));

            await axios.post(`${config.apiBASEURL}/user-profile/uploadUserDocuments`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            showMessage("success", "Documents uploaded successfully.");
            await fetchUserDocuments();
            setDocumentModal1(false);
        } catch (error) {
            console.error("Error uploading documents:", error);
            showMessage(
                "error",
                error.response?.data?.message || "Something went wrong while uploading."
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <CustomToast ref={toastRef} />

            <Form>
                <Row className="align-items-center mx-0">
                    {userDocuments && userDocuments.length > 0 && (
                        <Col md={12} className="mb-4 px-0">
                            <h6 className="text-secondary">
                                <small>Old Documents</small>
                            </h6>
                            <div className="d-flex gap-2 flex-wrap">
                                {userDocuments.map((doc, index) => (
                                    <img
                                        key={index}
                                        src={doc.document_url}
                                        alt={`Document ${index + 1}`}
                                        className="object-cover border p-1"
                                        style={{ width: '140px' }}
                                    />
                                ))}
                            </div>
                        </Col>
                    )}

                    <Col md={12} className="px-0">
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label className="text-dark">Update Documents (Max 2 total)</Form.Label>
                            <Form.Control
                                type="file"
                                multiple
                                onChange={handleFileChange}
                                accept=".pdf,.jpg,.jpeg,.png"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12} className="px-0">
                        {selectedFiles.length > 0 && (
                            <div>
                                <h6 className="text-secondary mb-2"><small>Selected Files:</small></h6>
                                <div className="d-flex gap-2">
                                    {selectedFiles.map((file, index) => (
                                        <div
                                            key={index}
                                            className="d-flex align-items-center justify-content-between border p-2 mb-2 rounded w-50 position-relative"
                                        >
                                            <span>{file.name}</span>
                                            <CiCircleRemove
                                                size={22}
                                                color="red"
                                                style={{ cursor: "pointer", position: "absolute", right: "0px", top: "0px" }}
                                                onClick={() => handleRemoveFile(index)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row className="m-0">
                    <div className="d-flex justify-content-end gap-2 p-0">
                        <Button
                            label={isLoading ? "Uploading..." : "Upload Documents"}
                            icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-upload"}
                            severity="warning"
                            className="py-2 border-0 "
                            onClick={handleUpload}
                            loading={isLoading}
                        />
                        <Button
                            label="Cancel"
                            severity="secondary"
                            className="py-2 border-0 "
                            onClick={() => setDocumentModal1(false)}
                        />
                    </div>
                </Row>
            </Form>
        </div>
    );
};

export default AddUserDocuments;
